
<template>
  <!-- Menu Page Start -->
  <section class="menu_page_area">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="menu_page_inn">
            <div class="menu_nav">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li role="presentation" v-for="(tab, key) in tabs" v-bind:key="key">
                  <a href="javascript:;" v-bind:class="{active: tab.isActive}" data-bs-toggle="tab"
                     data-bs-target="#all"
                     role="tab" aria-controls="all" aria-selected="true" @click.stop.prevent="setActive(tab)">{{ tab.title }}</a>
                </li>
              </ul>
            </div>
            <div class="tab-content" id="myTabContent">
              <div :class="{'tab-pane': true, fade: true, show: tab.isActive, active: tab.isActive}"
                   v-for="(tab, key) in tabs" :key="key" role="tabpanel" aria-labelledby="all-tab">
                <div class="row">
                  <div class="col-md-11 mx-auto">
                    <div class="food_menu_inn">
                      <div class="row justify-content-between">
                        <div class="col-lg-5 col-sm-6" v-for="(item, key) in getContents(tab)" :key="key">
                          <div class="menu_page_table">
                            <a class="food_menu_item" href="#" target="_self" rel="">
                              <div class="food_item_thumb">
                                <img v-bind:src="item.img" alt="img"/>
                              </div>
                              <div class="menu-item_content-wrap">
                                <div class="menu-item_content">
                                  <div class="menu-item_title">
                                    <h4>{{item.title}}</h4>
                                  </div>
                                  <div class="menu-item_price">
                                    <h4><span class="currencySymbol">{{item.currency}}</span>{{ item.price }}</h4>
                                  </div>
                                </div>
                                <div class="menu-item_desc">
                                  <p>{{item.description}}</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Menu Page End -->
</template>
<script>
export default {
  name: 'MenuPageArea',
  data() {
    return {
      activatedTab: {},
      tabs: [
        {
          title: 'All',
          category: 'all-tab',
          isActive: true
        },
        {
          title: 'Pizzas',
          category: 'pizza',
          isActive: false
        },
        {
          title: 'Salads',
          category: 'salad',
          isActive: false
        },
        {
          title: 'Pasta',
          category: 'pasta',
          isActive: false
        },
        {
          title: 'Burgers',
          category: 'burgers',
          isActive: false
        },
        {
          title: 'Deserts',
          category: 'deserts',
          isActive: false
        }
      ],
      tabContent: [
        {
          category: 'pizza',
          title: 'Santa Fe Pizza',
          description: 'Chicken breast, cheddar wrapped in a crispy',
          currency: '£',
          price: '20.70',
          img: require('../assets/img/pizza_slide_1.png')
        },
        {
          category: 'drinks',
          title: 'Coke Soft Drinks',
          description: 'Chicken breast, cheddar wrapped in a crispy',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/juice_3.png')
        },
        {
          category: 'drinks',
          title: 'Chocolate Donuts',
          description: 'Chicken breast, cheddar wrapped in a crispy',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/pizza_slide_3.png')
        },
        {
          category: 'drinks',
          title: 'Vanilla Ice Cream',
          description: 'Chocolate, Vanilla, Strwberry flavour',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/ice-cream-1.png')
        },
        {
          category: 'deserts',
          title: 'Lemon Juice',
          description: 'Orange, cheddar wrapped in a masala',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/juice_1.png')
        },
        {
          category: 'pasta',
          title: 'Black Hamburger',
          description: 'Breast cheddar wrapped in a erisy',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/burgur-1.png')
        },
        {
          category: 'pasta',
          title: 'Orange Spice Juice',
          description: 'Orange, Spice cheddar & Masala',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/juice_2.png')
        },
        {
          category: 'salad',
          title: 'Greek Salad',
          description: 'Vegetale, Tomato, etc..',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/salad_1.png')
        },
        {
          category: 'burgers',
          title: 'Chicken Hamburger',
          description: 'Vegetale, Tomato, etc..',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/bugar_2.png')
        },
        {
          category: 'burgers',
          title: 'Flavour Cream Ice',
          description: 'Chocolate, Vanilla, Strwberry flavour',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/ice-cream-2.png')
        },
        {
          category: 'burgers',
          title: 'Super Sicilian',
          description: 'Chicken breast, cheddar wrapped in a crispy',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/pizza_slide_4.png')
        },
        {
          category: 'deserts',
          title: 'Super Sicilian',
          description: 'Chicken breast, cheddar wrapped in a crispy',
          currency: '£',
          price: '12.50',
          img: require('../assets/img/pizza_slide_4.png')
        }
      ],
    }
  },
  methods: {
    getContents(tab) {
      const category = tab.category;

      if (category === 'all-tab') {
        return this.tabContent;
      }

      return this.tabContent.filter(item => item.category === category);
    },
    setActive(tab) {
      let me = this;
      tab.isActive = true;
      this.activatedTab = tab;

      this.tabs.forEach(function(tab) {
        if (tab.category !== me.activatedTab.category) {
          tab.isActive = false;
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MenuPageArea.vue